import { render, staticRenderFns } from "./DmsDataRefresh.vue?vue&type=template&id=2d47bb78&scoped=true&"
import script from "./DmsDataRefresh.vue?vue&type=script&lang=js&"
export * from "./DmsDataRefresh.vue?vue&type=script&lang=js&"
import style0 from "./DmsDataRefresh.vue?vue&type=style&index=0&id=2d47bb78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d47bb78",
  null
  
)

export default component.exports